import { graphql } from 'gatsby';
import {
  ContentfulRichTextGatsbyReference,
  RenderRichTextData,
} from 'gatsby-source-contentful/rich-text';
import React from 'react';

import { RichText } from '../../rich-text/rich-text';

export interface RichTextBlockProps {
  blocktype: 'ContentfulBlockRichText';
  id: string;
  name: string;
  richText: RenderRichTextData<ContentfulRichTextGatsbyReference>;
}

const RichTextBlock = ({ richText }: RichTextBlockProps) => {
  return richText ? <RichText richText={richText} /> : null;
};

export default RichTextBlock;

export const query = graphql`
  fragment RichTextBlock on ContentfulBlockRichText {
    blocktype: __typename
    id
    internalName
    richText {
      raw
      references {
        ...Asset
        ...Entry
      }
    }
  }
`;
